var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDataRequestSubmitted = function SvgDataRequestSubmitted(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    "aria-hidden": true,
    ref: ref
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#2ED376"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 8H8.5C7.67157 8 7 8.61561 7 9.375V17.625C7 18.3844 7.67157 19 8.5 19H18.5C19.3284 19 20 18.3844 20 17.625V9.375C20 8.61561 19.3284 8 18.5 8Z",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6V8M17 6V8",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10H7",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDataRequestSubmitted);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTMiIGN5PSIxMyIgcj0iMTMiIGZpbGw9IiMyRUQzNzYiLz4KPHBhdGggZD0iTTE4LjUgOEg4LjVDNy42NzE1NyA4IDcgOC42MTU2MSA3IDkuMzc1VjE3LjYyNUM3IDE4LjM4NDQgNy42NzE1NyAxOSA4LjUgMTlIMTguNUMxOS4zMjg0IDE5IDIwIDE4LjM4NDQgMjAgMTcuNjI1VjkuMzc1QzIwIDguNjE1NjEgMTkuMzI4NCA4IDE4LjUgOFoiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTkgNlY4TTE3IDZWOCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yMCAxMEg3IiBzdHJva2U9IndoaXRlIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";